<section id="section-news-articles" class="row" #newsArticles [ngStyle]="sectionColor==='grey' ? {'background-color': 'rgba(216, 216, 216, 0.15)',
    color: '#4a4a4a'} : {}">
  <div class="row">
    <h2 class="heading col-xs-10 col-xs-offset-1">We have been in the news</h2>
  </div>

  <div class="row">
    <p class="subheading-black col-xs-10 col-xs-offset-1 col-md-8 col-md-offset-2">
      Here's What The Media Has To Say About Us
    </p>
  </div>

  <div class="row">
    <div class="col-xs-12 col-md-10 col-md-offset-1">
      <div class="articles-container">

        <div class="article-tile" [ngStyle]="sectionColor==='grey' ? {'background-color': '#ffffff'} : {}">
          <a href="https://yourstory.com/2018/05/p2p-loan-marketplace-finzy-wants-change-india-sees-lending/"
             target="_blank" rel="nofollow">
            <img class="logo img-responsive center-block"
                 alt="Yourstory says finzy wants to change how India sees lending"
                 src="https://res.cloudinary.com/finzy/image/upload/v1539163245/news-articles/your-story_kcwnva.png">
            <p class="title">Finzy wants to change how India sees lending</p>
          </a>
        </div>

        <div id="times-of-india" class="article-tile" [ngStyle]="sectionColor==='grey' ? {'background-color': '#ffffff'} : {}">
          <a
              href="https://timesofindia.indiatimes.com/venture-capital/finzy-secures-2-3-million-in-pre-series-a-funding/articleshow/65477061.cms"
              target="_blank" rel="nofollow">
            <img class="logo img-responsive center-block"
                 alt="Times Of India mentions Finzy secures $2.3 million in pre-series A funding"
                 src="https://res.cloudinary.com/finzy/image/upload/v1539163245/news-articles/times-of-india_iarzlk.png">
            <p class="title">Finzy secures $2.3 million in pre-series A funding</p>
          </a>
        </div>

        <div class="article-tile" [ngStyle]="sectionColor==='grey' ? {'background-color': '#ffffff'} : {}">
          <a
              href="http://www.newindianexpress.com/business/2018/jul/04/finzy-receives-nbfc-p2p-certification-from-rbi-1838000.html"
              target="_blank" rel="nofollow">
            <img class="logo img-responsive center-block"
                 alt="New Indian Express mentions finzy receives NBFC-P2P certification from RBI"
                 src="https://res.cloudinary.com/finzy/image/upload/v1539163245/news-articles/indian-express_skrqdd.png">
            <p class="title">finzy receives NBFC-P2P certification from RBI</p>
          </a>
        </div>

        <div class="article-tile hidden-xs" [ngStyle]="sectionColor==='grey' ? {'background-color': '#ffffff'} : {}">
          <a
              href="https://economictimes.indiatimes.com/small-biz/startups/newsbuzz/millennials-tap-fintech-startups-for-holidays/articleshow/65144348.cms"
              target="_blank" rel="nofollow">
            <img class="logo img-responsive center-block"
                 alt="Economic Times writes about millenials wanting to work in fintech startups"
                 src="https://res.cloudinary.com/finzy/image/upload/v1539163245/news-articles/economic-times_msl8fl.png">
            <p class="title">Millenials tap fintech startups for holidays</p>
          </a>
        </div>

        <div class="article-tile hidden-xs" [ngStyle]="sectionColor==='grey' ? {'background-color': '#ffffff'} : {}">
          <a
              href="http://bwcio.businessworld.in/article/Finzy-to-Trigger-Pan-India-Channel-Tie-ups-for-P2P-Lending-Visibility-Amit-More/17-07-2018-154935/"
              target="_blank" rel="nofollow">
            <img class="logo img-responsive center-block"
                 alt="BW CIOWORLD writes about finzy's plan to go Pan-India for P2P lending visibility"
                 src="https://res.cloudinary.com/finzy/image/upload/v1539163245/news-articles/bw-ci-world_dfcyk3.png">
            <p class="title">Finzy to Trigger Pan-India Channel Tie-ups for P2P Lending
              Visibility</p>
          </a>
        </div>

        <div class="article-tile" [ngStyle]="sectionColor==='grey' ? {'background-color': '#ffffff'} : {}">
          <a
              href="https://techherald.in/emerging-business/startups/finzy-achieves-zero-defaults-in-the-first-year-of-operations/"
              target="_blank" rel="nofollow">
            <img class="logo img-responsive center-block"
                 alt="TechHerald writes about finzy achieving zero defaults in the first year of operations"
                 src="https://res.cloudinary.com/finzy/image/upload/v1539163246/news-articles/tech-herald_bnpn3o.png">
            <p class="title">Finzy achieves zero defaults in the first year of operations</p>
          </a>
        </div>

      </div>
    </div>
  </div>
</section>
